import React from "react";
import { Center, Inline } from "./center.styles";

export default ({ children }) => (
  <Center>
    <Inline>{children}</Inline>
  </Center>
);
